import React, { useEffect, useState } from "react";
import CrossIcon from "../../../assets/icons/cross_icon.svg";
import FilterIcon from "../../../assets/icons/icon-filter.svg";
import NextIcon from "../../../images/next.png";
import PreviousIcon from "../../../images/prev.png";
// import styles from "./style.module.css";
import ProfileImg from "../../../images/profile.png";
import NotificationIcon from "../../../images/icon-notifications.png";
import Sidebar from "../../partials/Sidebar";
import Header from "../../partials/Header";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import defaultAvatar from "../../../images/avatar.png";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { motion } from "framer-motion";
import HashLoader from "react-spinners/ClipLoader";
import fetchSiteList from "../../../api/sites/fetchSiteList";
import { formattedDate } from "./../../../utils/formulas";
const List = () => {
  const url = process.env.REACT_APP_APP_BACK_URL;
  const base_url = process.env.REACT_APP_BASE_URL;
  const [data, setData] = useState([]);
  const [getRoles, setRoles] = useState([]);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 8;
  const [getSite, setSite] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedRole, setSelectedRole] = useState("all");
  const [isActive, setIsActive] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  useEffect(() => {
    fetchData();
  }, [currentPage, searchValue, selectedRole]);

  const fetchData = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      setIsLoading(true);
      setIsDisplay(false);
      setIsNotFound(false);
      const response = await fetch(`${url}/api/timeout/get`, {
        mode: "cors",
        method: "GET",
        headers: headers,
      });
      setIsLoading(false);
      const json = await response.json();
      if (json.data.length > 0) {
        setIsDisplay(true);
      } else {
        setIsNotFound(true);
      }
      setData(json.data);
      //   setTotalPages(json.totalPages);
    } catch (error) {
      console.error(error);
    }
  };
  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1); // react-paginate uses zero-based indexing
  };

  const handleDelete = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        reverseButtons: true,
      });
      if (result.isConfirmed) {
        Swal.showLoading();
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Access-Control-Allow-Origin", "*");
        headers.append("Access-Control-Allow-Credentials", "true");
        headers.append("auth-token", localStorage.getItem("token"));
        const response = await fetch(`${url}/api/timeout/delete/${id}`, {
          mode: "cors",
          method: "DELETE",
          headers: headers,
        });
        if (response.ok) {
          fetchData(); // Refresh the records list after successful deletion
          Swal.fire("Deleted!", "User deleted successfully!", "success");
        } else {
          Swal.fire(
            "Error",
            "An error occurred while deleting the record.",
            "error"
          );
        }
      }
    } catch (error) {
      console.log("Error deleting record:", error);
      Swal.fire(
        "Error",
        "An error occurred while deleting the record.",
        "error"
      );
    }
  };

  return (
    <div className="general-dashboard mt-3">
      <div className="container-fluid">
        <div className="dashboard-top-row">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <div className="user-wrap">
                <h3>All TimeOuts</h3>
                <p>List of all timeouts added in the system</p>
              </div>
            </div>
            <div className="col-lg-6 text-end">
              <div className="filter-right-sec">
                <div className="filter-wrap">
                  {/* <div className="filter-box" onClick={toggleFilterSection}>
                    <img src={FilterIcon} alt="" />
                  </div> */}
                </div>
                <Link to="/time-out/add" className="btn btn-prim w-auto">
                  Add New TimeOut
                </Link>
              </div>
            </div>
          </div>
          {/* {isFilterVisible && (
            <>
              <motion.div
                className={`row mt-5 filter-section`}
                initial={{ opacity: 0 }} // Initial state (hidden)
                animate={{ opacity: isFilterVisible ? 1 : 0 }} // Animate opacity based on isFilterVisible
                transition={{ duration: 1.2, delay: 0.1 }}
              >
                <div className="col-12">
                  <div className="filter-right-sec filter-wrap-chat">
                    <div className="filter-select d-flex align-items-center">
                      <label htmlFor="">Role</label>
                      <select
                        name="role"
                        id=""
                        value={credentials.role}
                        onChange={handleInput}
                      >
                        <option value="all">Choose ROl</option>
                        {getRoles.map((per) => (
                          <option key={per._id} value={per.name}>
                            {per.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="filter-select d-flex align-items-center">
                      <label htmlFor="">Site</label>
                      <select
                        name="site"
                        id=""
                        value={credentials.site}
                        onChange={handleInput}
                      >
                        <option value="all">Choose site</option>
                        {getSite.map((per) => (
                          <option key={per._id} value={per._id}>
                            {per.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="filter-select d-flex align-items-center">
                      <label htmlFor="">Status</label>
                      <select
                        name="status"
                        id=""
                        value={credentials.status}
                        onChange={handleInput}
                      >
                        <option value="all">Choose Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                    <div className="search-wrap">
                      <input
                        type="search"
                        placeholder="search by username"
                        name="name"
                        value={credentials.name}
                        onChange={handleInput}
                      />
                      <div className="search-box">
                        <img src={SearchIcon} alt="" />
                      </div>
                    </div>
                    <Link
                      to=""
                      onClick={handleResetBtn}
                      className="btn btn-prim w-auto"
                    >
                      RESET
                    </Link>
                  </div>
                </div>
              </motion.div>
            </>
          )} */}
        </div>
        {/* row */}
        <div className="table-wrap">
          <div className="row">
            <div className="col-12">
              <div>
                <div>
                  <div className="table-responsive">
                    <table className="table align-middle">
                      <thead>
                        <tr>
                          {/* <th>#</th> */}
                          <th>Time</th>
                          <th>Type</th>
                          {/* <th>User</th>
                          <th>Status</th> */}
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading && (
                          <>
                            <tr>
                              <td
                                colSpan={6}
                                className="text-center"
                                style={{ background: "transparent" }}
                              >
                                <HashLoader
                                  color={`#0b0d41`}
                                  loading={isLoading}
                                  size={40}
                                  aria-label="Loading Spinner"
                                  data-testid="loader"
                                />
                              </td>
                            </tr>
                          </>
                        )}
                        {isDisplay &&
                          data.map((user, i) => (
                            <motion.tr
                              key={user._id}
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              transition={{ duration: 1.2, delay: i * 0.1 }}
                            >
                              <td>
                                <div className="usr_det_tb">
                                  <span className="text-lowercase">
                                    {user.time}
                                  </span>
                                </div>
                              </td>
                              <td>{user.type}</td>
                              {/* <td className="text-lowercase">{user.user}</td> */}

                              <td>
                                <div className="d-flex">
                                  {/* {user.status === "deactive" ? (
                                    <button
                                      type="button"
                                      className="btn btn-success tb-btn"
                                      onClick={() => {
                                        handelActive(user._id);
                                      }}
                                    >
                                      Active
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-edit tb-btn"
                                      disabled
                                    >
                                      Deactive
                                    </button>
                                  )} */}
                                  <Link
                                    type="button"
                                    className="btn btn-edit tb-btn"
                                    to={`/time-out/edit/${user._id}`}
                                  >
                                    Edit
                                  </Link>
                                  <button
                                    type="button"
                                    className="btn btn-delete tb-btn"
                                    onClick={() => handleDelete(user._id)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </td>
                            </motion.tr>
                          ))}
                        {isNotFound && (
                          <tr>
                            <td colSpan={7} className="text-center">
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* <div className="table-num">
                  <div className="dig-num">
                    <span>1</span> <Link to="/">2</Link>{" "}
                    <Link to="/">3</Link> <Link to="/">4</Link>{" "}
                  </div>
                  <div className="num-btns">
                    <Link to="/">
                      <img src={PreviousIcon} alt="" />
                    </Link>{" "}
                    <Link to="/">
                      <img src={NextIcon} alt="" />
                    </Link>
                  </div>
                </div> */}
                  <div className="table-num">
                    {data.length > 0 && (
                      <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        breakLabel={"..."}
                        pageCount={totalPages}
                        forcePage={currentPage - 1} // react-paginate uses zero-based indexing
                        onPageChange={handlePageChange}
                        containerClassName={" dig-num"}
                        pageClassName={"dig-num"}
                        previousClassName={"num-btns"}
                        nextClassName={"num-btns"}
                        disabledClassName={"pagination-disabled"}
                        activeClassName={"pagination-active"}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default List;
